// tslint:disable:no-duplicate-string
import { OrderFilter } from 'graphql-api/baskets-api-interfaces';

export const mockOrderBookFilters = [
  {
    displayName: 'Order Type',
    fieldId: 'OrderType',
    isMultiple: false,
    values: [
      {
        displayName: 'Future',
        count: 6358,
        value: 'Future',
      },
      {
        displayName: 'Now',
        count: 21468,
        value: 'Now',
      },
    ],
  },
  {
    displayName: 'Order Status',
    fieldId: 'Incoming',
    isMultiple: false,
    values: [
      {
        displayName: 'true',
        count: 3,
        value: 'true',
      },
      {
        displayName: 'false',
        count: 5,
        value: 'false',
      },
    ],
  },
  {
    displayName: 'Address (ship-to)',
    fieldId: 'Address',
    isMultiple: true,
    values: [
      {
        displayName: 'Westport Co. Mayo,Shop Street',
        count: 27826,
        value:
          '{"accountId":"fcbd8449-d822-48f7-8151-c0268a1308b0","addressId":"0001053419"}',
      },
    ],
  },
  {
    displayName: 'Delivery month',
    fieldId: 'DeliveryDate_requested',
    isMultiple: true,
    values: [
      {
        displayName: '2020-01-01T00:00:00Z',
        count: 5698,
        value: '2020-01-01T00:00:00Z',
      },
      {
        displayName: '2020-02-01T00:00:00Z',
        count: 597,
        value: '2020-02-01T00:00:00Z',
      },
      {
        displayName: '2021-06-01T00:00:00Z',
        count: 72,
        value: '2021-06-01T00:00:00Z',
      },
    ],
  },
  {
    displayName: 'Placed month',
    fieldId: 'Date_order',
    isMultiple: false,
    values: [
      {
        displayName: '2020-01-01T00:00:00Z',
        count: 5698,
        value: '2020-01-01T00:00:00Z',
      },
      {
        displayName: '2020-02-01T00:00:00Z',
        count: 597,
        value: '2020-02-01T00:00:00Z',
      },
      {
        displayName: '2020-09-01T00:00:00Z',
        count: 311,
        value: '2020-09-01T00:00:00Z',
      },
    ],
  },
  {
    displayName: 'Category',
    fieldId: 'RootAttribute_categoryname',
    isMultiple: false,
    values: [
      {
        displayName: '',
        count: 5698,
        value: '',
      },
    ],
  },
  {
    displayName: 'Sub brand',
    fieldId: 'RootAttribute_productlinename',
    isMultiple: true,
    values: [
      {
        displayName: '',
        count: 100,
        value: '',
      },
    ],
  },
] as OrderFilter[];

export const mockFilterYear = [
  {
    displayName: 'DeliveryDate',
    fieldId: 'DeliveryDate',
    isMultiple: false,
    values: [
      {
        count: 2,
        value: '2020-01-01T00:00:00Z',
      },
      {
        count: 4,
        value: '2021-01-01T00:00:00Z',
      },
    ],
  },
] as OrderFilter[];

export const myNoosFilter = {
  displayName: 'NOOS',
  fieldId: 'RootAttribute_isglobalnoos',
  isMultiple: false,
  values: [
    {
      displayName: 'True',
      count: 1,
      value: 'True',
    },
    {
      displayName: 'False',
      count: 2,
      value: 'False',
    },
    {
      displayName: '',
      count: 3,
      value: '',
    },
  ],
} as OrderFilter;
